import * as React from 'react';
import * as classNames from 'classnames';
import { Icon } from './Icon';

export interface IAlertIconProps {
    className?: string;
}

const AlertIcon = (props: IAlertIconProps) => {
    const className = classNames('elc-alert-icon', props.className);
    const image = `url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' preserveAspectRatio='none'%3E%3Cpath d='M256.001,35.11L0,476.89h512L256.001,35.11z M281.827,423.156H227.72v-52.297h54.107V423.156z M268.433,349.324H241.47 l-15.018-124.388v-67.613h56.64v67.613L268.433,349.324z' /%3E%3C/svg%3E")`;

    return <Icon className={className} size={'large'} image={image} />;
};

export { AlertIcon };
